(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const pauseAutoplayMedia = (root = document) => {
    if (!reducedMotion.matches) return;

    root.querySelectorAll('video[autoplay]').forEach((video) => {
      video.pause();
    });

    root.querySelectorAll('.swiper, swiper-container').forEach((carousel) => {
      carousel.swiper?.autoplay?.stop();
    });
  };

  const applyMotionPreference = () => {
    document.documentElement.classList.toggle('reduce-motion', reducedMotion.matches);
    pauseAutoplayMedia();
  };

  const focusMainContent = (event) => {
    const skipLink = event.target.closest('[data-skip-link]');
    if (!skipLink) return;

    const targetId = skipLink.hash || '#MainContent';
    const main = document.querySelector(targetId);
    if (!main) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    main.setAttribute('tabindex', '-1');
    main.focus({ preventScroll: true });
    main.scrollIntoView({ block: 'start' });
    window.history.replaceState(null, '', targetId);
  };

  document.addEventListener('click', focusMainContent, true);
  document.addEventListener('shopify:section:load', (event) => {
    pauseAutoplayMedia(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMotionPreference, { once: true });
  } else {
    applyMotionPreference();
  }

  window.loadSwiper?.then(() => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => pauseAutoplayMedia());
    });
  });

  reducedMotion.addEventListener?.('change', applyMotionPreference);
})();
